<template>
  <v-select
    id="country-selector"
    v-model="innerValue"
    name="country-selector"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    label="name"
    :options="countries"
    :reduce="item => item.id"
    :placeholder="placeholder"
    autocomplete="chrome-off"
  />
</template>

<script>
import Category from '@nollaSdk/models/Category'
import CountriesMixin from '@/mixins/CountriesMixin'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  mixins: [CountriesMixin],
  $_veeValidate: {
    name() {
      return this.name
    },
    value() {
      return this.value
    },
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      innerValue: this.value,
      items: [],
    }
  },
  watch: {
    innerValue() {
      this.$emit('input', this.innerValue)
    },
  },
  mounted() {
    this.findItems()
  },
  methods: {
    findItems() {
      Category.findAll('/place-chronology')
        .then(models => {
          this.items = models
        })
    },
  },
}
</script>
